import { Winner } from '@fantaz/shared/data-access/models';
import { createReducer, on, Action } from '@ngrx/store';

import * as WinnerActions from './winner.actions';

export const WINNER_FEATURE_KEY = 'winner';

export interface WinnerState {
  data?: Winner;
  params?: {
    eventInstanceId: string;
    playInstanceId: string;
  };
  loaded: boolean;
  loading: boolean;
  processing: boolean;
  error?: string | null;
}

export interface WinnerPartialState {
  readonly [WINNER_FEATURE_KEY]: WinnerState;
}

export const initialState: WinnerState = {
  // set initial required properties
  loaded: false,
  loading: false,
  processing: false,
};

const winnerReducer = createReducer(
  initialState,
  on(
    WinnerActions.load,
    (state, { eventInstanceId, playInstanceId, confirmedNow }) => ({
      ...state,
      loaded: false,
      loading: true,
      error: null,
      params: {
        eventInstanceId,
        playInstanceId,
      },
      data: {
        ...state?.data,
        data: {
          ...state.data?.data,
          confirmedNow,
        },
      } as Winner,
    }),
  ),
  on(WinnerActions.loadWinnerSuccess, (state, { winner }) => ({
    ...state,
    loaded: true,
    loading: false,
    data: {
      ...state?.data,
      message: winner.message,
      data: {
        ...state.data?.data,
        ...winner.data,
      },
    } as Winner,
  })),
  on(WinnerActions.loadWinnerFailure, (state, { error }) => ({
    ...state,
    loaded: true,
    loading: false,
    error,
  })),
  // confirm winner
  on(WinnerActions.confirm, (state) => ({
    ...state,
    processing: true,
    error: null,
  })),
  on(WinnerActions.confirmWinnerSuccess, (state) => ({
    ...state,
    confirming: false,
    data: {
      ...state?.data,
      data: {
        ...state.data?.data,
        confirmedNow: true,
      },
    } as Winner,
  })),
  on(WinnerActions.confirmWinnerFailure, (state, { error }) => ({
    ...state,
    processing: false,
    error,
  })),
);

export function reducer(state: WinnerState | undefined, action: Action) {
  return winnerReducer(state, action);
}
